/**
 * Enum for CRUD actions
 * @readonly
 * @enum { string }
 */
enum Action {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete'
}

export default Action
